import { useDispatch } from 'react-redux';
import { useMutation } from '@tanstack/react-query';
import { showLoading, closeLoading } from '../../Reducer/LoadingReducer';

const useDeleteMutation = (mutationFn, options = {}) => {
  const dispatch = useDispatch();

  const mutation = useMutation({
    mutationFn,

    onMutate: async (vars) => {
      dispatch(showLoading());
      await options.onMutate?.(vars);
    },

    onSuccess: (response, vars, context) => {
      if (response.severity === 'error') {
        const err = new Error(response.message);
        err.response = response;
        options.onError?.(err, vars, context);
        throw err;
      }

      options.onSuccess?.(response, vars, context);
      return response;
    },

    onError: (error, vars, context) => {
      options.onError?.(error, vars, context);
    },

    onSettled: (data, error, vars, context) => {
      dispatch(closeLoading());
      options.onSettled?.(data, error, vars, context);
    },
  });

  const run = (vars) => mutation.mutate(vars);
  const runAsync = (vars) => mutation.mutateAsync(vars);

  return { ...mutation, run, runAsync };
};

export default useDeleteMutation;
